import { useEffect, useState } from 'react';
import { useLocation } from 'wouter';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const [ , setLocation ] = useLocation();
  const { isAuthenticated } = useAuth();
  const [ error, setError ] = useState<string | null>(null);

  useEffect(() => {
    // Check URL for error parameters
    const queryParams = new URLSearchParams(window.location.search);
    const errorCode = queryParams.get('errorCode');
    const errorMsg = queryParams.get('errorMsg');

    if (errorCode && errorMsg) {
      // If there are errors, redirect to home (which shows the landing page)
      setLocation(`/?errorCode=${errorCode}&errorMsg=${errorMsg}`, { replace: true });
      return;
    }

    // Otherwise, try to verify session and redirect
    const verifySession = async () => {
      try {

        if (isAuthenticated) {
          // Successful login, redirect to home
          setLocation('/', { replace: true });
        } else {
          // Failed to authenticate, redirect to home (shows landing page)
          setLocation('/', { replace: true });
        }
      } catch (error) {
        console.error('Failed to verify session:', error);
        setError('Failed to verify your authentication status. Please try again.');

        // Redirect to home after a short delay
        setTimeout(() => {
          setLocation('/', { replace: true });
        }, 3000);
      }
    };

    verifySession();
  }, [ isAuthenticated, setLocation ]);

  return (
    <div className="min-h-screen bg-[#0E1525] flex flex-col items-center justify-center p-4">
      <div className="text-center">
        {error ? (
          <div className="text-red-400">
            <p>{error}</p>
            <p className="mt-2 text-gray-400">Redirecting...</p>
          </div>
        ) : (
          <>
            <Loader2 className="h-12 w-12 animate-spin mx-auto text-[#11B981]"/>
            <h2 className="mt-6 text-xl font-medium text-white">Completing authentication...</h2>
            <p className="mt-2 text-gray-400">Please wait while we verify your session</p>
          </>
        )}
      </div>
    </div>
  );
}